<ion-select
  [fill]="fill ?? undefined"
  [class.required]="required"
  [placeholder]="placeholder"
  [label]="label"
  [labelPlacement]="labelPlacement"
  [justify]="justify"
  [mode]="mode ?? undefined"
  [helperText]="helperText"
  [attr.required]="required"
  [name]="name"
  [disabled]="disabled"
  [multiple]="multiple"
  interface="popover"
  [interfaceOptions]="interfaceOptions || {}"
  [compareWith]="compareWith"
  [cancelText]="cancelText"
  [okText]="okText"
  [selectedText]="selectedText"
  [value]="currentValue"
  (ionChange)="handleChange($event)"
  (ionBlur)="handleBlur($event)"
  (ionFocus)="ionFocus.emit($event)"
>
  <ng-content></ng-content>
</ion-select>
